import React from "react";
import Chart from "react-apexcharts";
import { Card, CardContent, Box } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
const DayOfWeeklySales = ({ AnalyticsData }) => {
  const daysOfWeek = ["M", "T", "W", "T", "F", "S", "S"];
  const fullDayNames = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const saleData = AnalyticsData?.weeklySaleSummary || AnalyticsData;
  const salesByDay = new Map();
  if (saleData) {
    saleData.forEach((item) => {
      salesByDay.set(item.dayOfWeek, item);
    });
  }
  const completeWeekData = fullDayNames.map((fullDay) => {
    const dayData = salesByDay.get(fullDay);
    return {
      day: fullDay,
      amount: dayData
        ? CurrencyConverter.toCurrency(dayData.totalAmount || 0, "INR")
        : 0,
    };
  });

  const top3Amounts = [...completeWeekData]
    .sort((a, b) => b.amount - a.amount)
    .slice(0, 3)
    .map((item) => item.amount);

  const mainColor = "#303f9f";
  const lighterColor = "#d0d4f9ff";

  const barColors = completeWeekData.map((dayData) =>
    top3Amounts.includes(dayData.amount) ? mainColor : lighterColor
  );

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      parentHeightOffset: 0,
      animations: {
        enabled: false,
      },
    },
    legend: {
      show: false,
    },
    colors: barColors,
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "60%",
        borderRadius: 10,
        distributed: true,
        states: {
          hover: {
            filter: {
              type: "none",
            },
          },
          active: {
            filter: {
              type: "none",
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: daysOfWeek,
      labels: {
        style: {
          colors: ["#888", "#888", "#888", "#888", "#888", "#888", "#888"],
          fontWeight: 600,
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
      crosshairs: {
        show: false,
      },
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: false,
    },
    fill: {
      colors: barColors,
    },
    tooltip: {
      enabled: true,
      x: {
        formatter: function (value, { w, dataPointIndex }) {
          const fullDayNames = [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ];
          // const dayIndex = w.globals.labels.indexOf(value);
          return `<b>${fullDayNames[dataPointIndex]}</b>`;
        },
      },
      y: {
        formatter: (value) => {
          return `₹${value.toLocaleString()}`;
        },
      },
      marker: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const barColor = w.globals.colors[dataPointIndex];
          return `<span style="background-color: ${barColor}; width: 12px; height: 12px; border-radius: 10%; margin-right: 8px;"></span>`;
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
        },
      },
    },
  };

  const chartSeries = [
    {
      name: "Sales",
      data: completeWeekData.map((d) => d.amount),
    },
  ];

  const highestSalesDay = saleData?.reduce((max, current) => {
    return CurrencyConverter.toCurrency(current.totalAmount, "INR") >
      CurrencyConverter.toCurrency(max.totalAmount, "INR")
      ? current
      : max;
  }, saleData[0]);

  return (
    <>
      <Card sx={{ boxShadow: "none" }}>
        <CardContent className="p-2">         
            <>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={250}
              />
{saleData?.length > 0 && (
              <Box sx={{ p: 1, pt: 1 }}>
                <h6 className="mb-1 ">Highest Sales Day</h6>

                <p className="mb-0 fs-13 ">
                  Total ₹
                  {CurrencyConverter.toCurrency(
                    highestSalesDay?.totalAmount || 0,
                    "INR"
                  )}{" "}
                  on {highestSalesDay?.dayOfWeek}
                </p>
              </Box>
              )}
            </>          
          
        </CardContent>
      </Card>
    </>          
  );
};

export default DayOfWeeklySales;
